import Constants from 'Shared/constants';

import types from './types';

const appLanguage = document.getElementById('viato-contract-generator').dataset.lng;

const initialState = {
	activePage: Constants.PAGES.LANDING_PAGE,
	language: appLanguage
};

function appReducer(state = initialState, action) {
	switch (action.type) {
		case types.SET_ACTIVE_PAGE:
			return {
				...state,
				activePage: action.payload
			};
		case types.SET_LANGUAGE:
			return {
				...state,
				language: action.payload
			};
		default:
			return state;
	}
}

export default appReducer;
